// frontend/klaes-app/src/components/FilmFavs/utils/helpers.js

// Farben für Chip-Kategorien (zentrale Definition)
export const categoryColors = {
  genre: '#3b82f6',
  mood: '#f59e0b',
  era: '#10b981',
  country: '#ef4444',
  theme: '#8b5cf6',
  misc: '#ec489a',
  actor_regisseur: '#06b6d4'
};

// Kategorien für TagPicker (zentrale Definition)
export const tagCategories = [
  { id: 'all', label: 'All', icon: '🎲' },
  { id: 'genre', label: 'Genre', icon: '🎬' },
  { id: 'mood', label: 'Mood', icon: '😊' },
  { id: 'era', label: 'Era', icon: '📅' },
  { id: 'country', label: 'Country', icon: '🌍' },
  { id: 'theme', label: 'Theme', icon: '🎯' },
  { id: 'misc', label: 'Misc', icon: '📌' },
  { id: 'actor_regisseur', label: 'Actor/Regisseur', icon: '🎭' }
];

// Batterie-Level berechnen
export const getBatteryLevel = (rating) => {
  if (rating <= 16.5) return { level: 1, color: 'red' };
  if (rating <= 33) return { level: 2, color: 'red' };
  if (rating <= 66) return { level: 3, color: 'orange' };
  if (rating <= 83.5) return { level: 4, color: 'green' };
  return { level: 5, color: 'green' };
};